<table-list 
    [resource]="equipeResource" 
    [filterConfiguration]="filterConfiguration"
    [service]="equipeService"
></table-list>